if (!customElements.get('description-spec-table')) {
        class DescriptionSpecTable extends HTMLElement {
          constructor () {
            super()
            this.maxShownItems = parseInt(this.dataset.maxShownItems) || 9;
            this.handleVariantChange = this.handleVariantChange.bind(this)
            this.handleToggleLineItems = this.handleToggleLineItems.bind(this)
          }

          connectedCallback () {
            this.tables = this.querySelectorAll('.variant-description-spec-table')
            this.addEventListener('click', this.handleToggleLineItems)
            document.addEventListener('variant:change', this.handleVariantChange)
            this.initTables()
          }

          disconnectedCallback () {
            this.removeEventListener('click', this.handleToggleLineItems)
            document.removeEventListener('variant:change', this.handleVariantChange)
          }

          initTables () {
            this.tables.forEach(table => {
              const items = table.querySelectorAll('.table-item')
              const button = table.querySelector('.table-items-toggle__button')
              if (items.length > this.maxShownItems) {
                items.forEach((item, i) => item.hidden = i >= this.maxShownItems)
                if (button) button.setAttribute('aria-expanded', 'false')
              } else if (button) {
                button.hidden = true
              }
            })
          }

          handleToggleLineItems (event) {
            const button = event.target.closest('.table-items-toggle__button')
            if (!button) return

            const expanded = button.getAttribute('aria-expanded') === 'true'
            const table = button.closest('.variant-description-spec-table__table')
            const items = table.querySelectorAll('.table-item')

            button.setAttribute('aria-expanded', String(!expanded))
            items.forEach((item, i) => item.hidden = !expanded ? false : i >= this.maxShownItems)
          }

          handleVariantChange (event) {
            const currentId = event.detail.variant.id?.toString()
            if (!currentId || !this.tables) return

            this.tables.forEach(table => {
              const tableId = table.dataset.variantId?.toString()
              table.classList.toggle('hidden', tableId !== currentId)
            })
          }
        }

        customElements.define('description-spec-table', DescriptionSpecTable)
      }